import './main.css'
import '../App.css'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../Pages/messageModal';
import { ChevronRight, Copyright, ArrowDownToLine } from 'lucide-react';
import { useThree } from 'react-three-fiber';
import { useDispatch, useSelector } from 'react-redux';
import { changeAlramModal, changeEnergy, changeHaptic, changeLanguages, changeSound } from '../store';
import { useTranslation } from "react-i18next";
import i18n from '../lang/i18n';

function Setting() {
    const { t } = useTranslation();
    let dispatch = useDispatch()
    let haptic = useSelector((state) => { return state.haptic.value })
    let sound = useSelector((state) => { return state.sound.value })
    let Languages = useSelector((state) => { return state.Languages.value })
    let mobileType = useSelector((state) => { return state.mobileType.value })

    const [message, setMessage] = useState("");

    const [btn, setBtn] = useState(0)

    const onClickHaptic = () => {
        dispatch(changeHaptic(haptic ? false : true))
    }

    const onClickSound = () => {
        dispatch(changeSound(sound ? false : true))

    }

    const [page, setPage] = useState(false)

    const onChangeLanguage = (e) => {
        i18n.changeLanguage(e);
        dispatch(changeLanguages(e));
        if (Languages != e) {
            setMessage({ "code": 0, "msg": `${t('message_2')}` })
            dispatch(changeAlramModal())
        }
    }

    const onClickDarkLight = () => {
        setMessage({ "code": 0, "msg": `${t('message_3')}` })
        dispatch(changeAlramModal())
    }

    return (
        <div className='main notheader'>
            <MessageModal message={message} />
            <div className='settings'>
                <div className='settings-header'>{t('setting_0')}</div>
                {page && (<Language setPage={setPage} Languages={Languages} onChangeLanguage={onChangeLanguage} />)}
                <div className={`settings-list ${btn === 0 ? "active" : ""}`} onClick={() => { setBtn(0); setPage(true) }}>
                    <div className='settings-list-text1'>{t('setting_1')}</div>
                    <div className='settings-list-text2'>{Languages == "en-US" ? "English" : Languages == "ko-KR" ? "한국어" : "Tiếng Việt"}</div>
                    <ChevronRight className='settings-list-icon' size={32} />
                </div>
                <div className={`settings-list ${btn === 1 ? "active" : ""}`} onClick={() => onClickDarkLight()}>
                    <div className='settings-list-text1'>{t('setting_2')}</div>
                    <div className='settings-list-text2'>Dark</div>
                    <ChevronRight className='settings-list-icon' size={32} />
                </div>
                {/* <div className={`settings-list disable ${btn === 2 ? "active" : ""}`} >
                    <div className='settings-list-text1'>{t('setting_3')}</div>
                    <ChevronRight className='settings-list-icon' size={32} />
                </div> */}
                <div className='settings-toggle'>
                    <div>{t('setting_4')}</div>
                    <div className='menu-2-1-2'>
                        <div className={`toggle-box ${haptic ? 'toggled' : ''}`} onClick={() => onClickHaptic()}>
                            {
                                haptic
                                    ?
                                    <span className={`toggle-box-on`}></span>
                                    :
                                    <span className={`toggle-box-off`}></span>
                            }
                            <div className="toggle-box-btn slider"></div>
                        </div>
                    </div>
                </div>
                <div className='settings-toggle'>
                    <div>{t('setting_5')}</div>
                    <div className='menu-2-1-2'>
                        <div className={`toggle-box ${sound ? 'toggled' : ''}`} onClick={() => onClickSound()}>
                            {
                                sound
                                    ?
                                    <span className={`toggle-box-on`}></span>
                                    :
                                    <span className={`toggle-box-off`}></span>
                            }
                            <div className="toggle-box-btn slider"></div>
                        </div>
                    </div>
                </div>
                <div className={`settings-list ${btn === 1 ? "active" : ""}`} style={{ marginTop: "10px" }}
                    onClick={() => window.open(
                        mobileType == 0
                            ? "https://play.google.com/store/apps/details?id=com.feelspic.securet&hl=ko&pli=1"
                            : "https://apps.apple.com/kr/app/securet-for-communication-%EC%8B%9C%ED%81%90%EB%A6%BF/id6451279827")}>
                    <div style={{ display: 'flex', gap: "5px" }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <img src='/newImg/securet.png' style={{ width: "30px" }} />
                        </div>
                        <div>
                            <div className='settings-list-text1'>Download</div>
                            <div className='settings-list-text2'>{mobileType == 0 ? "Android" : "IOS"}</div>
                        </div>
                    </div>
                    <ArrowDownToLine className='settings-list-icon' size={25} />
                </div>

                <div className='setting-sns'>
                    <div className='loading-5-1' onClick={() => window.open('https://t.me/')}><img src='/img/telegram.svg' style={{ width: "25px" }} /></div>
                    <div className='loading-5-1' onClick={() => window.open('https://youtube.com/')}><i className="fa-brands fa-youtube"></i></div>
                    <div className='loading-5-1' onClick={() => window.open('https://x.com/')}><i className="fa-brands fa-x-twitter"></i></div>
                </div>
                {/* <div className='setting-licenses'>
                    <div style={{ display: "flex", alignItems: 'center', justifyContent: 'center' }}>
                        <Copyright size={14} style={{ marginRight: "3px" }} />
                        {t('setting_7')}
                    </div>
                    <div style={{ display: "flex", alignItems: 'center', justifyContent: 'center', gap: "10px" }}>
                        <a href="https://www.flaticon.com/kr/free-icons/" title="로켓 아이콘" style={{ fontSize: "10px" }}>로켓 아이콘 제작자: Freepik - Flaticon</a>
                        <span>,</span>
                        <a href="https://www.flaticon.com/kr/free-icons/" title="우뢰 아이콘" style={{ fontSize: "10px" }}>우뢰 아이콘 제작자: Freepik - Flaticon</a>
                    </div>
                </div> */}
            </div>
        </div>

    )
}

function Language({ setPage, Languages, onChangeLanguage }) {
    const { t } = useTranslation();
    const [now, setNow] = useState(Languages)

    return (
        <div className='modal'>
            <div className='modal-background' onClick={() => setPage(false)}></div>
            <div className='airdrop-modal'>
                <FontAwesomeIcon icon={faCircleXmark} className='modal-x' onClick={() => setPage(false)} />
                <div className={`settings-list-text3 ${now === "en-US" ? "active" : ""}`} onClick={() => { setNow("en-US") }}>
                    <img src='/img/united-states.png' style={{ width: "25px" }} />
                    <div>English</div>
                </div>
                <div className={`settings-list-text3 ${now === "ko-KR" ? "active" : ""}`} onClick={() => { setNow("ko-KR") }}>
                    <img src='/img/south-korea.png' style={{ width: "25px" }} />
                    <div>한국어</div>
                </div>
                <div className={`settings-list-text3 ${now === "vi-VN" ? "active" : ""}`} onClick={() => { setNow("vi-VN") }}>
                    <img src='/img/Vietnam.png' style={{ width: "25px" }} />
                    <div>Tiếng Việt</div>
                </div>
                <div className='modal-airdrop-btn' style={{ marginBottom: "10px", background: "#5b60f6" }} onClick={() => { onChangeLanguage(now); setPage(false) }}>{t('setting_6')}</div>
            </div>
        </div>
    )
}


export default Setting;